import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }

import SfxBtnIcon from "src/components/button/SfxBtnIcon.vue"
import SfxContextBar from "src/components/navigation/SfxContextBar.vue"
import router from "src/router"
import { ContextAction } from "src/util/enums/entityType"
import { Icons } from "src/util/enums/fontAwesomeIcons"
import { NamedPath } from "src/util/enums/namedPaths"
import { NavigationAction } from "src/util/enums/topNavigation"
import { computed, PropType } from "vue"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxTopNavigation',
  props: {
  title: {
    type: String,
  },

  titleReference: {
    type: String,
  },

  titleClass: {
    type: String,
  },

  titleReferenceClass: {
    type: String,
  },

  subtitleClass: {
    type: String,
  },

  navigationAction: {
    type: Number as PropType<NavigationAction>,
    default: undefined,
  },

  quickAction: Number as PropType<ContextAction>,

  menuContent: Array as PropType<Array<ContextAction>>,

  disabledMenuContent: Array as PropType<Array<ContextAction>>,

  disableQuickAction: Boolean,

  disableMenu: Boolean,

  hideContextMenu: Boolean,

  hideContextBar: Boolean,

  disableNotifications: Boolean,

  hideNotifications: Boolean,

  hideSeparator: Boolean,
},
  emits: ["close", "contextSelect"],
  setup(__props, { emit: __emit }) {

const props = __props

const emit = __emit

//endregion

//region Variables

const actionIcon = computed(() => {
  switch (props.navigationAction) {
    case NavigationAction.HISTORY_BACK:
      return Icons.CHEVRON_LEFT
    case NavigationAction.CLOSE:
      return Icons.CLOSE_LARGE
    default:
      return null
  }
})

const subtitleClass = computed(
  () => props.subtitleClass ?? "sfx-top-navigation__subtitle text-weight-regular"
)

//endregion

//region Functions

function actionClicked() {
  switch (props.navigationAction) {
    case NavigationAction.HISTORY_BACK:
      if (!router.options.history.state.back) {
        router.push({ name: NamedPath.SELECT_WORKSPACE })
      } else {
        router.back()
      }
      break
    case NavigationAction.CLOSE:
      emit("close")
      break
  }
}

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!

  return (_openBlock(), _createBlock(_component_q_toolbar, { class: "sfx-top-navigation" }, {
    default: _withCtx(() => [
      (actionIcon.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(SfxBtnIcon, {
              class: "sfx-top-navigation__action",
              padding: "sm",
              icon: actionIcon.value,
              onClick: actionClicked
            }, null, 8, ["icon"])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_q_toolbar_title, { class: "text-weight-bold" }, {
        default: _withCtx(() => [
          _createElementVNode("span", {
            class: _normalizeClass(`sfx-top-navigation__title-${_ctx.$slots.subtitle ? 'small' : 'big'}`)
          }, [
            (props.titleReference)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass(["text-weight-regular q-mr-xs", props.titleReferenceClass])
                }, _toDisplayString(props.titleReference), 3))
              : _createCommentVNode("", true),
            (props.title)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  class: _normalizeClass(props.titleClass)
                }, _toDisplayString(props.title), 3))
              : _renderSlot(_ctx.$slots, "title", { key: 2 })
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["ellipsis", subtitleClass.value])
          }, [
            _renderSlot(_ctx.$slots, "subtitle")
          ], 2)
        ]),
        _: 3
      }),
      (!props.hideContextBar)
        ? (_openBlock(), _createBlock(SfxContextBar, {
            key: 1,
            onContextSelect: _cache[0] || (_cache[0] = (item) => emit('contextSelect', item)),
            "quick-action": props.quickAction,
            "menu-content": props.menuContent,
            "disabled-menu-content": props.disabledMenuContent,
            "disable-menu": props.disableMenu,
            "hide-context-menu": props.hideContextMenu,
            "disable-notifications": props.disableNotifications,
            "hide-notifications": props.hideNotifications,
            "disable-quick-action": props.disableQuickAction,
            "hide-separator": props.hideSeparator
          }, null, 8, ["quick-action", "menu-content", "disabled-menu-content", "disable-menu", "hide-context-menu", "disable-notifications", "hide-notifications", "disable-quick-action", "hide-separator"]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}
}

})